import React, { useState, useEffect } from 'react'
import { Container, Breadcrumb, BreadcrumbItem, Row, Col, Label, Input, Button, InputGroup, InputGroupText } from 'reactstrap'
import { NavLink } from 'react-router-dom'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import { homePageUrl } from '../../../helpers/Constants';

function NotCompiled() {

    let [calendarValue, setCalenderValue] = useState(new Date());
    let [showCalender, setShowCalender] = useState(false)
    let [selectedDate, setSelectedDate] = useState("")

    const [startDate, setStartDate] = useState(new Date());

    useEffect(() => {
        setSelectedDate(`${calendarValue.getDate()}/${calendarValue.getMonth()+1}/${calendarValue.getFullYear()}`)
    }, [calendarValue])

  return (
    <section className='lyt-section'>
        <Container fluid className='typ-container'>
            <Breadcrumb className='bs-breadcrumb mt-0'>
                <BreadcrumbItem><NavLink to={`reports`}>Reports</NavLink></BreadcrumbItem>
                <BreadcrumbItem><NavLink href="#">HDFC_worli_compl.officer_Dn0_Date</NavLink></BreadcrumbItem>
                <BreadcrumbItem><NavLink href="#">Legislation</NavLink></BreadcrumbItem>
                <BreadcrumbItem active>Legislation 1</BreadcrumbItem>
            </Breadcrumb>
            <div className='bs-card px-0'>
                <div className='padding-area'>
                    <h1 className='bs-heading typ-rule'>Procedure for nomination <span className='rule'>Rule 3</span></h1>
                    <p className='bs-para typ-desc'><span className='bold'>Compliance Description :</span> Every employed person makes a declaration nominating a person conferring the right to receive the amount that may stand in his credit at the event of his death, before that amount has become payable or where the amount has become payable, before payment has been made.</p>
                    <p className='bs-para'><span className='bold'>Penalty Type :</span>  Fine</p>
                    <p className='bs-para'><span className='bold'>Penalty Description :</span>  Fine which may extend to Rs 7500/-</p>
                </div>
                <div className='mod-divider'></div>
                <div className='padding-area'>
                    <form className="bs-form">
                        <Row>
                            <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                                <Label for="doj" className="mr-sm-2 cstm-label">Date of Compliance</Label>
                                <div className='calender-area'>
                                    <DatePicker selected={startDate} onChange={(date:Date) => setStartDate(date)} placeholderText="Enter Date of Joining" />
                                </div>
                            </Col>
                            <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                                <Label for="status" className="mr-sm-2 cstm-label">Status</Label>
                                <div className='select-option'>
                                    <Input className='typ-select mb' type="select" name="select" id="exampleSelect">
                                        {/* <option>Compiled</option> */}
                                        <option>Not Compiled</option>
                                        {/* <option>Not Applicable</option>
                                        <option>Compiled With Exception</option> */}
                                    </Input>
                                </div>
                            </Col>
                            <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                                <Label for="doj" className="mr-sm-2 cstm-label">Due Date of Completion</Label>
                                <div className='calender-area'>
                                    <DatePicker selected={startDate} onChange={(date:Date) => setStartDate(date)} placeholderText="Enter Due Date of Completion" />
                                </div>
                            </Col>
                            <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                                <Label for="exampleText" className='cstm-label'>Reason</Label>
                                <Input type="textarea" name="text" className='cstm-input' rows="5" id="exampleText" placeholder='Type Here...' />
                            </Col>
                            <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                                <Label for="exampleEmail" className="mr-sm-2 cstm-label">Upload Proof of File</Label>
                                <div className='position-relative'>
                                    <Input type="file" name="email" className='file-input' id="exampleEmail" placeholder="Enter Email ID" />
                                    <InputGroup>
                                        <Input placeholder="No File Choosen" className='mb-0'/>
                                        <InputGroupText>Choose File</InputGroupText>
                                    </InputGroup>
                                </div>
                            </Col>
                            <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                                <Label for="status" className="mr-sm-2 cstm-label">Criticality</Label>
                                <div className='select-option'>
                                    <Input className='typ-select mb' type="select" name="select" id="exampleSelect">
                                        {/* <option>Compiled</option> */}
                                        <option>Select Criticality</option>
                                        {/* <option>Not Applicable</option>
                                        <option>Compiled With Exception</option> */}
                                    </Input>
                                </div>
                            </Col>
                            <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                                <Label for="exampleText" className='cstm-label'>Comment of Officer</Label>
                                <Input type="textarea" name="text" className='cstm-input' rows="5" id="exampleText" placeholder='Type Here...' />
                            </Col>
                            <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                                <Label for="exampleText" className='cstm-label'>Description</Label>
                                <Input type="textarea" name="text" className='cstm-input' rows="5" id="exampleText" placeholder='Type Here...' />
                            </Col>
                            <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                                <button className='bs-btn btn-submit'>SUBMIT</button>
                            </Col>
                        </Row>
                    </form>  
                </div>
            </div>
        </Container>
    </section>
  )
}

export default NotCompiled
